import { render, staticRenderFns } from "./SyncLogPage.vue?vue&type=template&id=267da6b7&scoped=true&"
import script from "./SyncLogPage.vue?vue&type=script&lang=js&"
export * from "./SyncLogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267da6b7",
  null
  
)

export default component.exports